<script setup lang="ts">
import { type SelectionItem } from '@models/selectionItem.ts';
import Typography from '@components/Typography.vue';
import StreetDistrict from '@components/offer-card/StreetDistrict.vue';
import OfferPrice from '@components/offer-card/OfferPrice.vue';
import { OfficeType } from '@enums/officeType.ts';
import { computed } from 'vue';

const props = defineProps<{ selectionItem: SelectionItem }>();

// @todo : refacto in composable
const isSingleOpenspace = computed<boolean>(
  () => props.selectionItem.offers.length <= 1 && props.selectionItem.offer.office_type?.code === OfficeType.OPEN_SPACE,
);
</script>

<template>
  <div class="selection-item-minified">
    <Typography
      as="h4"
      variant="content-heading-2"
    >
      <StreetDistrict :address="selectionItem.offer.address" />
    </Typography>

    <OfferPrice
      :offer="selectionItem.offer"
      :price="selectionItem.total_price"
      :is-single-openspace="isSingleOpenspace"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-minified {
  border: 1px solid $colorGray;
  border-radius: rem(8);
  width: 100%;
  padding: rem(8) rem(12) rem(12) rem(12);
  background-color: $colorWhite;
}
</style>
